import React from 'react';
import { ArrowRight } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = '¡QUIERO MI LICENCIA CDL AHORA!',
  subtext,
  className = '',
  href = '#precio',
  onClick
}: CTAButtonProps) {
  const isExternal = href && !href.startsWith('#');
  const handleClick = (e: React.MouseEvent) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    // Fire Meta Pixel AddToCart for external checkout links
    if (isExternal && window.fbq) {
      try {
        window.fbq('track', 'AddToCart', {
          content_name: 'CDL Class A: El Atajo',
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
      } catch (err) {
        console.warn('Meta Pixel AddToCart error:', err);
      }
    }
    onClick?.();
  };
  return <a href={href} onClick={handleClick} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`group relative flex flex-col items-center justify-center w-full sm:w-auto cursor-pointer no-underline ${className}`} data-id="element-13">
      <div className="absolute -inset-1 bg-amber-500 rounded-lg blur opacity-40 group-hover:opacity-75 transition duration-300" data-id="element-14"></div>
      <div className="relative w-full flex items-center justify-center gap-3 px-8 py-5 bg-amber-500 hover:bg-amber-400 text-slate-900 rounded-lg font-oswald font-bold text-xl md:text-2xl uppercase tracking-wide transition-all transform group-hover:-translate-y-1 shadow-[0_0_20px_rgba(245,158,11,0.4)]" data-id="element-15">
        <span data-id="element-16">{text}</span>
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-17" />
      </div>
      {subtext && <span className="mt-3 text-sm text-slate-400 font-medium text-center" data-id="element-18">
          {subtext}
        </span>}
    </a>;
}